import React from 'react';
import AdminLoginForm from './AdminLoginForm';

export default function AdminLogin() {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <AdminLoginForm />
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.85rem' }}>
          <a href="/" style={{ color: '#888' }}>← Back to Website</a>
        </p>
      </div>
    </div>
  );
}
